import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  FormGroup,
  Modal,
  Form,
  CardHeader,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Kycpage from "./KycPage";
import UserAddress from "./UserAddress";
import Editaddress from "./Editaddress";

const CourseCart = () => {
  const [packagedata, setPackage] = useState({});
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [imagePath, setImagePath] = useState("");
  const [coupons, setCoupons] = useState([]);
  const [address, setAddress] = useState([]);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showKycModal, setShowKycModal] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token"); // your auth token
  // your auth token
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => {
    setShow(false);
    setShow2(true);
  };
  const [deletingId, setDeletingId] = useState(null);

  // Fetch cart data
  useEffect(() => {
    const fetchCartData = async () => {
      try {
        const userId = localStorage.getItem("user_id");
        const plan_id = localStorage.getItem("plan_id");

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/course-cart-payment`,
          { user_id: userId, id: plan_id }
        );

        if (response.data.status === "1") {
          const data = response.data.data;
          setPackage(data);
          console.log(data);
          setImagePath(data.imagePath);
          setFinalAmount(parseFloat(data.amount));

          // Auto-fill coupon if available
          // if (data.coupons && data.coupons.length > 0) {
          //   setCoupons(data.coupons);
          //   setCode(data.coupons[0].code);
          // }
        } else {
          toast.error("Failed to fetch cart data");
        }
      } catch (err) {
        console.error("Cart API error:", err);
        toast.error("Something went wrong");
      }
    };

    fetchCartData();
  }, []);
  useEffect(() => {
    const fetchCouponData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/coupon-list`
        );

        if (res.data.status === "1") {
          // If API returns an array, filter active coupons
          let couponList = Array.isArray(res.data.data)
            ? res.data.data.filter((c) => c.status === "active")
            : res.data.data.status === "active"
            ? [res.data.data]
            : [];

          setCoupons(couponList);

          // Set first active coupon as default
          if (couponList.length > 0) setCode(couponList[0].code);
        } else {
          setCoupons([]);
          setCode("");
        }
      } catch (error) {
        toast.error("Failed to fetch coupons");
      }
    };

    fetchCouponData();
  }, []);

  useEffect(() => {
    fetchAddressData();
  }, []);
  const fetchAddressData = async () => {
    try {
      const userId = localStorage.getItem("user_id");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user-address-list`,
        { user_id: userId }
      );

      if (response.data.status === "1") {
        const data = response.data.data;

        // agar response object hai to array banao
        if (Array.isArray(data)) {
          setAddress(data);
        } else {
          setAddress([data]);
        }
      } else {
        // toast.error("Failed to fetch address data");
      }
    } catch (err) {
      console.error("Address API error:", err);
      toast.error("Something went wrong");
    }
  };

  const handleChange = (e) => {
    setCode(e.target.value);
  };

  // Load Razorpay script
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // Handle payment
  const handleRazorpayPayment = async () => {
    const mobile = localStorage.getItem("mobile");
    if (packagedata.user?.kyc === "pending") {
      swal({
        title: "Profile Incomplete",
        text: "Please complete your profile to proceed with payment.",
        icon: "warning",
        timer: 2000,
        buttons: false,
      });

      setShowKycModal(true);
      return;
    }
    if (!selectedAddress) {
      swal({
        title: "Address Required",
        text: "Please select a delivery address before proceeding with payment.",
        icon: "warning",
        timer: 2000,
        buttons: false,
      });
      return; // stop payment
    }

    if (!isChecked) {
      toast.error("Please accept terms & conditions");
      return;
    }
    setLoading(true);

    try {
      const res = await loadRazorpayScript();
      if (!res) {
        toast.error("Razorpay SDK failed to load. Are you online?");
        setLoading(false);
        return;
      }
      const amountToPay = selectedEmi
        ? appliedCoupon
          ? selectedEmi.emi_amount - appliedCoupon.discount_value
          : selectedEmi.emi_amount
        : appliedCoupon
        ? finalAmount
        : parseFloat(packagedata.discount_amount || 0);

      const orderPayload = {
        user_id: localStorage.getItem("user_id"),
        amount: Math.round(amountToPay), // convert INR to paise
        currency: "INR",
        package_plan_id: packagedata.id, // existing
        emi_plan_id: selectedEmi ? selectedEmi.id : null,
      };

      const orderResponse = await axios.post(
        `${process.env.REACT_APP_BASE_URL_PAYMENT}/createOrder`,
        orderPayload
      );

      if (!orderResponse.data.success) {
        toast.error("Order creation failed");
        setLoading(false);
        return;
      }

      const { razorpay_order_id, key_id, amount } = orderResponse.data;
      // alert(mobile);
      const options = {
        key: key_id,
        amount: Math.round(finalAmount), // always in paise
        currency: "INR",
        name: packagedata.package_name,
        description: "Course Enrollment",
        order_id: razorpay_order_id,
        contact: mobile,
        handler: async (response) => {
          await handleApplyCouponAfterPayment(response, amountToPay);
        },
        prefill: {
          name: localStorage.getItem("user_name") || "",
          email: localStorage.getItem("user_email") || "",
          contact: mobile || "",
        },
        theme: { color: "#3399cc" },
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function (response) {
        toast.error(`Payment failed: ${response.error.description}`);
        setLoading(false);
      });

      rzp.open();
      setLoading(false);
    } catch (err) {
      console.error("Payment initiation error:", err);
      toast.error("Failed to initiate payment");
      setLoading(false);
    }
  };

  const handleApplyCouponAfterPayment = async (response, paidAmount) => {
    setLoading(true);
    try {
      const userId = localStorage.getItem("user_id");
      const planMonths = packagedata.title
        ? parseInt(packagedata.title.match(/\d+/)[0], 10)
        : 0;
      const startDate = new Date();
      const endDate = new Date(startDate);
      if (planMonths > 0) {
        endDate.setMonth(endDate.getMonth() + planMonths);
        endDate.setDate(endDate.getDate() - 1);
      }

      const emi_planDays = selectedEmi ? selectedEmi.valid_days : "";
      const emi_startDate = new Date();
      const emi_endDate = new Date(emi_startDate);
      if (emi_planDays > 0) {
        emi_endDate.setDate(emi_endDate.getDate() + emi_planDays - 1);
      }

      const planRes = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user-plan-add`,
        {
          user_id: userId,
          coupon_code: code,
          package_id: packagedata.package_id,
          course_id: packagedata.course_id,
          amount: paidAmount,
          package_plan_id: packagedata.id,
          emi_plan_id: selectedEmi ? selectedEmi.id : null,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
          emi_day: selectedEmi ? selectedEmi.valid_days : "",
          day: planMonths,
          start_date: startDate.toISOString().split("T")[0],
          end_date: endDate.toISOString().split("T")[0],
          emi_start_date: selectedEmi ? emi_startDate.toISOString().split("T")[0] : "",
          emi_end_date: selectedEmi ? emi_endDate.toISOString().split("T")[0] : "",
          payment_id: response.razorpay_payment_id,
          status: "active",
          payment_status: selectedEmi ? "installment_pay" : "complet_pay",
        }
      );

      if (planRes.data.success === "1") {
        swal({
          title: "Success",
          text: "Payment successful and course enrolled!",
          icon: "success",
          timer: 2000,
          buttons: false,
        });
        setTimeout(() => navigate("/dashboard"), 2000);
      } else {
        swal("Error", planRes.data.message || "Failed to enroll", "error");
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleApplyCoupon = () => {
    if (!code) {
      setError("Please enter a coupon code");
      return;
    }

    const coupon = coupons.find((c) => c.code === code);
    if (!coupon) {
      setError("Invalid coupon code");
      setDiscount(0);
      setFinalAmount(packagedata.discount_amount || 0);
      setAppliedCoupon(null);
      return;
    }

    let calculatedDiscount = 0;
    const originalAmount = parseFloat(packagedata.discount_amount || 0);

    if (coupon.discount_type === "percentage") {
      calculatedDiscount = (originalAmount * coupon.discount_value) / 100;
      if (coupon.max_discount && calculatedDiscount > coupon.max_discount) {
        calculatedDiscount = coupon.max_discount;
      }
    } else {
      // Flat discount
      calculatedDiscount = Math.min(coupon.discount_value, originalAmount);
    }

    const newFinalAmount = Math.max(0, originalAmount - calculatedDiscount);

    setDiscount(calculatedDiscount);
    setFinalAmount(newFinalAmount);
    setAppliedCoupon(coupon);
    setError(null);
  };

  // Function to strip HTML and limit text
  const truncateDescription = (htmlString, limit = 200) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    const text = tempDiv.textContent || tempDiv.innerText || "";

    if (text.length > limit) {
      return text.substring(0, limit) + "...";
    }
    return text;
  };

  const handleEditAddress = (addr) => {
    console.log("Edit Address:", addr);
  };

  const handleDeleteAddress = async (id) => {
    if (!window.confirm("Are you sure you want to delete this address?"))
      return;

    try {
      const userId = localStorage.getItem("user_id");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user-address-delete`,
        { user_id: userId, id: id }
      );

      if (response.data.status === "1") {
        setAddress(address.filter((addr) => addr.id !== id));
        toast.success("Address deleted successfully");
        fetchAddressData();
      } else {
        toast.error(response.data.message || "Failed to delete address");
      }
    } catch (err) {
      console.error("Delete Address API error:", err);
      toast.error("Something went wrong while deleting the address");
    }
  };

  const [showModal, setShowModal] = useState(false);
  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => setShowModal(false);
  const [editaddress, setEditaddress] = useState(false);

  const editaddressshow = (addr) => {
    localStorage.setItem("edit_address_id", addr.id);
    setEditaddress(true);
  };

  const editaddressclose = () => setEditaddress(false);
  return (
    <section className="course_plan cart">
      <div className="page_header"></div>
      <ToastContainer position="top-right" autoClose={2000} />
      {showKycModal && (
        <Kycpage
          onComplete={() => {
            setShowKycModal(false);
            toast.success("Profile completed. You can now proceed to payment!");
          }}
        />
      )}

      <Container>
        <div className="py-60">
          <h4 className="mb-3 fw-semibold">Complete your purchase</h4>
          <Row className="gy-2">
            <Col lg={8} md={7} sm={12} xs={12}>
              <Card className="shadow-sm mb-3 card d-flex align-items-center justify-content-between flex-row gap-2">
                {selectedAddress ? (
                  <input
                    className="form-control address_box"
                    type="text"
                    readOnly
                    value={`${selectedAddress.name} (${selectedAddress.mobile}) ${selectedAddress.house_no}, ${selectedAddress.road_name_area}, ${selectedAddress.land_mark}, ${selectedAddress.state}, ${selectedAddress.city}, ${selectedAddress.pin_code}, ${selectedAddress.district}`}
                  />
                ) : (
                  <p className="ms-3">Please select an address</p>
                )}
                <div className="p-2 item_box text-end">
                  <button
                    className="educate-btn sm me-2 btn-primary"
                    onClick={handleShow}
                  >
                    <span className="educate-btn__curve"></span>Change Address
                  </button>
                </div>
              </Card>

              {packagedata.emi_status === "yes" &&
                packagedata.packageemi &&
                packagedata.packageemi.length > 0 && (
                  <Card className="plan_box cart shadow-sm">
                    <div className="p-2 item_box">Pay through installments</div>
                    <div className="p-2">
                      <Form.Select
                        value={selectedEmi?.id || ""}
                        onChange={(e) => {
                          const emi = packagedata.packageemi.find(
                            (item) => item.id === parseInt(e.target.value)
                          );
                          setSelectedEmi(emi);
                        }}
                      >
                        <option value="">Select Installment Option</option>
                        {packagedata.packageemi.map((emi) => {
                          const isPaid =
                            packagedata.user_purchase_emi &&
                            packagedata.user_purchase_emi.some(
                              (up) => up.emi_plan_id == emi.id
                            );
                          return (
                            <option
                              key={emi.id}
                              value={emi.id}
                              disabled={isPaid}
                            >
                              Installment {emi.section_number} - ₹
                              {emi.emi_amount} {isPaid ? "(Paid)" : ""}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </div>
                  </Card>
                )}

              {packagedata.emi_status === "yes" &&
                (!packagedata.packageemi ||
                  packagedata.packageemi.length === 0) && (
                  <p className="text-muted mt-2">
                    No Installment options available
                  </p>
                )}

              <Card className="plan_box cart shadow-sm mt-3">
                <div className="p-2 item_box">Cart Item</div>

                <Card.Body className="d-flex align-items-center justify-content-between">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="package_img">
                      <img
                        src={`${imagePath}${packagedata.image}`}
                        alt="package"
                        className="img-fluid"
                      />
                    </div>
                    <div className="cart_item">
                      <div className="coursName">
                        <div className="plan_select">
                          <Card.Title>{packagedata.package_name}</Card.Title>
                        </div>
                        <div className="dicount_Plan border-0">
                          <div className="plan_amount gap-2 d-flex fw-bold">
                            <span className="totalAmount">
                              ₹{packagedata.discount_amount}
                            </span>
                            {packagedata.amount && (
                              <span
                                style={{
                                  textDecoration: "line-through",
                                  color: "grey",
                                }}
                              >
                                ₹{packagedata.amount}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <Card.Text>
                        {truncateDescription(packagedata.description, 200)}
                      </Card.Text>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={5} sm={12} xs={12}>
              <Card className="shadow-sm">
                <Card.Body>
                  {/* Coupon Apply / Cancel */}
                  {appliedCoupon ? (
                    <div className="d-flex align-items-center justify-content-between border p-2 rounded mb-3">
                      <p className="mb-0">
                        Coupon Applied: <strong>{code}</strong>
                      </p>
                      <button
                        className="educate-btn bg-primary sm ms-2"
                        onClick={() => {
                          setAppliedCoupon(null); // Coupon reset
                          setCode(""); // Coupon code reset
                          setFinalAmount(packagedata.discount_amount || 0); // Final amount reset
                          setDiscount(0); // Discount reset
                          toast.info("Coupon removed");
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <FormGroup className="d-flex align-items-stretch gap-2">
                      <input
                        type="text"
                        value={code}
                        maxLength={22}
                        onChange={handleChange}
                        placeholder="Enter Coupon code"
                        className="form-control w-75"
                      />
                      <button
                        className="educate-btn sm w-25"
                        type="button"
                        onClick={handleApplyCoupon}
                      >
                        <span className="educate-btn__curve"></span>Apply
                      </button>
                    </FormGroup>
                  )}

                  {/* Discount Info */}
                  {appliedCoupon && (
                    <div className="payment_box">
                      <div className="discount_box mt-3 p-3 rounded bg-light border">
                        <p className="mb-1">
                          <span>Discount Type:</span>{" "}
                          {appliedCoupon.discount_type === "percentage"
                            ? `${appliedCoupon.discount_value}%`
                            : `Flat ₹${appliedCoupon.discount_value}`}
                        </p>
                        <p className="mb-1 color-primary-2">
                          <span>You saved:</span> ₹{discount.toFixed(2)}
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Payment Details */}
                  <div className="payment_box bg-light mt-3 rounded border">
                    <Card className="shadow-sm">
                      <CardHeader>Payment Details</CardHeader>
                      <Card.Body>
                        {/* EMI & Final Amount Logic */}
                        {selectedEmi ? (
                          <>
                            <p className="mb-1">
                              <strong>Selected Installment Plan:</strong>{" "}
                              {selectedEmi.section_number}
                            </p>
                            <p className="mb-1">
                              <strong>Duration:</strong>{" "}
                              {selectedEmi.valid_days} Days
                            </p>
                            {/* <p className="mb-1">
                              <strong>EMI Status:</strong> {selectedEmi.status}
                            </p> */}
                            {appliedCoupon ? (
                              <h5 className="mt-2">
                                Final Instalment Amount:{" "}
                                <span className="text-success">
                                  ₹
                                  {selectedEmi.emi_amount -
                                    appliedCoupon.discount_value}
                                </span>
                              </h5>
                            ) : (
                              <h5 className="mt-2">
                                Amount to Pay Now:{" "}
                                <span className="text-success">
                                  ₹{selectedEmi.emi_amount}
                                </span>
                              </h5>
                            )}
                          </>
                        ) : (
                          <>
                            {appliedCoupon ? (
                              <h5 className="mt-2">
                                Final Amount:{" "}
                                <span className="text-success">
                                  ₹{finalAmount}
                                </span>
                              </h5>
                            ) : (
                              <h5 className="mt-2">
                                Amount to Pay:{" "}
                                <span className="text-success">
                                  ₹{packagedata.discount_amount}
                                </span>
                              </h5>
                            )}
                          </>
                        )}
                        {selectedEmi && (
                          <div className="text-end mt-2">
                            <button
                              className="educate-btn sm bg-primary"
                              onClick={() => {
                                setSelectedEmi(null);
                                toast.info(
                                  "EMI selection removed. Full payment applied."
                                );
                              }}
                            >
                              Cancel Installment
                            </button>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </div>

                  {/* Terms Checkbox */}
                  <div className="form-group term_checkbox m-1">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      id="exampleCheck1"
                      onChange={(e) => setIsChecked(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="exampleCheck1">
                      I have read all{" "}
                      <a target="_blank" href="/terms">
                        term &amp; conditions
                      </a>
                      .
                    </label>
                  </div>

                  {/* Proceed Button */}
                  <button
                    onClick={() => handleRazorpayPayment()}
                    className="educate-btn w-100 mt-2 ms-0"
                    disabled={loading}
                  >
                    {loading ? "Processing..." : "Proceed to Payment"}
                  </button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>

      {/* Saved Address Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="enquire_form"
        backdrop="static"
      >
        <button
          type="button"
          className="custom-close-btn"
          onClick={handleClose}
        >
          ×
        </button>
        <Modal.Header className="address_header">
          <span>Saved Address</span>
          <Link onClick={openModal}>+ Add New Address</Link>
        </Modal.Header>
        {editaddress && <Editaddress closeModal={editaddressclose} />}
        {showModal && <UserAddress closeModal={closeModal} />}

        <Modal.Body>
          {address.length === 0 ? (
            <p>No saved addresses found.</p>
          ) : (
            address.map((addr, i) => (
              <div key={i} className="border rounded p-2 mb-2">
                {/* Radio button + address text */}
                <div className="d-flex align-items-start">
                  <input
                    type="radio"
                    name="selectedAddress"
                    className="me-2 mt-1"
                    onChange={() => setSelectedAddress(addr)}
                  />
                  <div>
                    <p className="fw-bold mb-1">
                      {addr.name} ({addr.mobile})
                    </p>
                    <p className="mb-1">
                      {addr.house_no}, {addr.road_name_area}, {addr.land_mark}
                    </p>
                    <p className="mb-1">
                      {addr.state}, {addr.city}, {addr.pin_code}
                    </p>
                    <p className="mb-0">District: {addr.district}</p>
                  </div>
                </div>

                {/* Buttons under address */}
                <div className="mt-2">
                  <button
                    className="me-2 educate-btn sm"
                    onClick={() => editaddressshow(addr)}
                  >
                    Edit
                  </button>
                  <button
                    className="educate-btn bg-primary sm"
                    onClick={() => handleDeleteAddress(addr.id)}
                    disabled={deletingId === addr.id}
                  >
                    {deletingId === addr.id ? "Deleting..." : "Delete"}
                  </button>
                </div>
              </div>
            ))
          )}
        </Modal.Body>
      </Modal>

      {/* Add New Address Modal */}
      {/* <Modal
        show={show2}
        onHide={handleClose2}
        centered
        className="enquire_form"
        backdrop="static"
      >
        <button
          type="button"
          className="custom-close-btn"
          onClick={handleClose2}
        >
          ×
        </button>
      </Modal> */}
    </section>
  );
};

export default CourseCart;
